// DT
import React from "react";
import styled from "styled-components";

import scale from "../helper/scaling";
import ArticleAbstract from "./ArticleAbstract";

const Wrapper = styled.div`
  width: 100%;
  float: left;

  padding-top: 30px;
  padding-bottom: 55px;

  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 1100px) {
    width: calc(100% - 50px);
    padding: ${scale(1100, 767, 30, 25, "vw")} 25px
      ${scale(1100, 767, 55, 52, "vw")} 25px;
  }
`;
const BorderBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 1100px) {
    width: 100%;
    float: left;
    justify-content: space-between;
  }
`;
const Image = styled.div`
  width: 355px;
  height: 237px;

  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;

  @media (max-width: 1100px) {
    width: ${scale(1100, 767, 355, 249, "vw")};
    height: ${scale(1100, 767, 237, 166, "vw")};
  }
`;
const Body = styled.div`
  width: 614px;
  padding: 0 40px 0 28px;

  font-family: Lato;
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.67;
  letter-spacing: 1.3px;
  color: rgba(0, 0, 0, 0.85);

  border-left: solid 3px #ff5368;

  @media (max-width: 1100px) {
    width: 10px;
    flex-grow: 1;

    font-size: ${scale(1100, 767, 18, 12, "vw")};
    line-height: ${scale(1100, 767, 18 * 1.67, 12 * 1.75, "vw")};

    letter-spacing: 0.8px;
  }
`;

class ArticleRedLined extends ArticleAbstract {
  // image
  // title
  // body
  render() {
    return (
      <Wrapper>
        <BorderBox>
          <Body>{this.body()}</Body>
          <Image style={this.image()} />
        </BorderBox>
      </Wrapper>
    );
  }
}

export default ArticleRedLined;



// WEBPACK FOOTER //
// ./src/components/ArticleRedLined.js